import Towngas from "../images/casesPage/towngas.png";

const painterCases = [
    Towngas
]

export default painterCases;